import { Component, OnInit } from '@angular/core';
import {  ActivatedRoute } from '@angular/router';
import { AlertsService } from "@jaspero/ng2-alerts";

import { GUID } from "app/brightserve/brightserve.module";
import { Client } from "app/shared/shared.module";
import { ClientsService } from "app/clients/clients.service";
import { Subscription } from "rxjs/Subscription";

@Component({
    selector: 'app-clients-detail',
    templateUrl: './clients-detail.component.html',
    styleUrls: ['./clients-detail.component.css']
})
export class ClientsDetailComponent implements OnInit {

    Id: GUID;
    Client: Client;
    GetClientSubscription: Subscription;
    sub: Subscription;

    constructor(private _alert: AlertsService, private clientService: ClientsService, private activatedRoute: ActivatedRoute) { };

    ngOnInit() {
        this.sub = this.activatedRoute.params.subscribe(params => {
            if (params && params['id']) {
                this.Id = params['id'];
                this.GetClient();
            }
        });
    };

    ngOnDestroy() {
        this.sub.unsubscribe();
        this.GetClientSubscription.unsubscribe();
    }

    GetClient() {
        this.GetClientSubscription = this.clientService.GetClient(this.Id).subscribe(
            client => {
                this.Client = client;
            }, err => {
                console.log(err);
            });
    };
}



// WEBPACK FOOTER //
// ./src/app/clients/details/clients-detail.component.ts